import React from "react";
import AppBar, { AppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

interface SectionHeaderProps {
    children: JSX.Element | JSX.Element[];
    position?: AppBarProps["position"];
    light?: boolean;
}

export const SectionHeader = ({
    children,
    position = "relative",
    light = false,
}: SectionHeaderProps) => {
    return (
        <AppBar
            position={position}
            sx={{ bgcolor: light ? "lightBlue.main" : "primary.dark" }}
        >
            <Toolbar variant="dense">{children}</Toolbar>
        </AppBar>
    );
};
